<template>	
	<c-checkbox
		id="test"
		name="test"
		:noMargin="true"
		:options="[
			{label: '', value: value},
		]">
	</c-checkbox>

	<!-- <c-checkbox
		:noMargin="true"
		:options="[
			{label:'', value:'1'},
		]">
	</c-checkbox> -->

</template>

<script>
import Form from '@mixins/Form';
import Column from '@mixins/Column';

export default {
    mixins: [ Form, Column ],
    props: {
        route: {
            type: String,
            required: false
        },
		value: {
            required: true
		}
    }
}
</script>
